<template>
  <div class="pay-type-div">
    <van-radio-group v-model="payType">
      <van-cell clickable @click="sCouponObj.length > 0 ? '' : (payType = '1')">
        <template #icon>
          <img class="pay-type-logo" src="../../assets/wallet.png" />
        </template>
        <template #title>
          <div class="pay-type">
            <span class="pay-type-text">余额支付</span>
            <span class="pay-account-sum" v-if="sCouponObj.length > 0" style="color: #ff0137">（不可与优惠券叠加使用）</span>
            <span v-else class="pay-account-sum">（剩余：¥{{ sUserInfo.amount }}）</span>
          </div>
        </template>
        <template #right-icon>
          <van-radio name="1" :disabled="sCouponObj.length > 0 ? true : false" />
        </template>
      </van-cell>
      <van-cell v-if="isWechated == 0 || payWay.payH5 != 2" clickable @click="payType = '2'">
        <template #icon>
          <img class="pay-type-logo" src="../../assets/wechat.png" />
        </template>
        <template #title>
          <div class="pay-type">
            <span class="pay-type-text">微信支付</span>
          </div>
        </template>
        <template #right-icon>
          <van-radio name="2" />
        </template>
      </van-cell>
      <van-cell v-if="isWechated == 1 && payWay.payH5 != 3" clickable @click="payType = '3'">
        <template #icon>
          <img class="pay-type-logo" src="../../assets/alipay.png" />
        </template>
        <template #title>
          <div class="pay-type">
            <span class="pay-type-text">支付宝支付</span>
          </div>
        </template>
        <template #right-icon>
          <van-radio name="3" />
        </template>
      </van-cell>
    </van-radio-group>
    <div class="do-pay-btn">
      <van-button :disabled="payType == '0'" @click="createOrder()" :loading="payLoading"
        :color="this.$enum.CONSTANT.APP_THEME_COLOR">确认支付</van-button>
    </div>
    <van-popup get-container="#app" v-model="showDialog" round @close="handleClosePopup">
      <div class="choosepay" v-if="isWechated == 1 && payWay.payH5 == 1">
        <!-- parseFloat(orderPrice+'').toFixed(2) -->
        <span>余额{{ sUserInfo.amount }}元，剩余<span style="color: #ff0137">{{ parseFloat(priceToAmount).toFixed(2)
            }}元</span></span>
        <span>请选择补差价方式</span>
        <!-- 防抖 -->
        <div class="btnbox">
          <van-button color="#009fe9" style="padding: 4px 0; border-radius: 8px" @click="handleBalanceToOther(2)">
            <div class="paybtn">
              <img class="pay-type-logo paybtnimg" src="../../assets/alipay.png" alt="" /><span>支付宝支付</span>
            </div>
          </van-button>
          <van-button color="#02c686" style="padding: 4px 0; border-radius: 8px" @click="handleBalanceToOther('')">
            <div class="paybtn">
              <img class="pay-type-logo paybtnimg" src="../../assets/wxpay.png" alt="" /><span>微信支付</span>
            </div>
          </van-button>
        </div>
      </div>
      <div class="choosepay" v-else>
        <span style="font-size: 16px">{{ messages }}</span>
        <van-button plain type="info" class="othbtn" @click="handleBalanceToOther(null)">确定</van-button>
      </div>
    </van-popup>
  </div>
</template>
<!-- function debounce(func, wait = 500) {
  let timeout = null;
  return function (...args) {
      clearTimeout(timeout)
      timeout = setTimeout(() => {
          func.apply(this, args)
      }, wait);
  }
} -->
<script>
import {
  addOrder,
  getBalancePay,
  getWeixinPay,
  getYuedongAccount,
  getAliPay,
  getAlliPayStatus,
  otherGetWxPay,
  isPayedByBalance,
  saveUnit,
} from "@/request/api";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import {
  Cell,
  CellGroup,
  RadioGroup,
  Radio,
  Button,
  Notify,
  Dialog,
  Popup,
} from "vant";
export default {
  name: "PayType",
  computed: {
    ...mapGetters([
      "sUserInfo",
      "getGoodsList",
      "sShop",
      "orderPrice",
      "sCouponObj",
      "sSortGood",
      "sSortCoup",
    ]),
    priceToAmount() {
      if (this.orderPrice) {
        return this.orderPrice - this.sUserInfo.amount;
      } else {
        return this.payedPrice - this.sUserInfo.amount;
      }
    },
  },
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [RadioGroup.name]: RadioGroup,
    [Popup.name]: Popup,
    [Radio.name]: Radio,
    [Button.name]: Button,
    [Notify.name]: Notify,
    [Dialog.name]: Dialog,
  },
  props: ["code", "orderId", "orderPayType", "payedPrice"],
  data() {
    return {
      payType: "0",
      orderUUID: "",
      messages: "",
      orderIndex: false,
      payLoading: false, // 支付一次之后
      showDialog: false,
      sortGoodList: [],
      sortCardList: [],
      timer: null,
      _orderId: null, // 弹窗用，支付不用
      isWechated: 0,
      count: 0,
      payWay: localStorage.getItem("payWay")
        ? JSON.parse(localStorage.getItem("payWay"))
        : { payH5: 3, payWx: 2 },
    };
  },
  beforeMount() {
    this.isWechated = this.isWechat();
    // alert(`${this.isWechated}`);
    // console.log(this.orderPrice,this.payedPrice);
  },
  methods: {
    ...mapMutations([
      "clearGoodsList",
      "setOrderId",
      "sSetUserInfo",
      "setHfOrderId",
    ]),
    sordedBy() {
      let glist = [];
      let clist = [];
      this.sortGoodList = [];
      this.sortCardList = [];
      if (this.sSortGood.length > 0) {
        for (let i = 0; i < this.sSortGood.length; i++) {
          const element = this.sSortGood[i];
          glist.push(this.getGoodsList.find((item) => item.goodsId == element));
        }
      }
      if (this.sSortCoup) {
        for (let i = 0; i < this.sSortCoup.length; i++) {
          const element = this.sSortCoup[i];
          let item = this.sCouponObj.find((item) => item.userCardId == element);
          clist.push(item);
        }
      }
      if (!this.orderId) {
        glist.forEach((item) => {
          this.sortGoodList.push(
            `${item.goodsId}|${item.specs[0].specId}|${item.specs[0].itemId}`
          );
        });
      } else {
        glist.forEach((item) => {
          this.sortGoodList.push(`${item.goodsId}`);
        });
      }
      for (let i = 0; i < glist.length; i++) {
        if (clist[i]) {
          // userCardId
          this.sortCardList.push(clist[i].userCardId);
        }
        // 对没有使用优惠券的商品添加空值占位
        // else{
        // 	this.sortCardList.push('')
        // }
      }
    },
    // 关闭选择支付方式弹窗
    handleClosePopup() {
      this.payLoading = false;
      this.showDialog = false;
      this.orderIndex = false;
    },

    //
    handleBalanceToOther(usehf) {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        if (this.isWechated == 0) {
          if (this.payWay.payWx == 1) {
            this.toBalancePay(this.isWechated, this._orderId, 1);
          } else {
            this.toBalancePay(this.isWechated, this._orderId, "");
          }
        } else {
          if (this.payWay.payH5 == 1) {
            this.toBalancePay(this.isWechated, this._orderId, usehf);
          } else if (this.payWay.payH5 == 2) {
            this.toBalancePay(this.isWechated, this._orderId, 2);
          } else {
            this.toBalancePay(this.isWechated, this._orderId, "");
          }
        }
      }, 500);
      this.showDialog = false;
    },
    //创建订单
    createOrder() {
      let uuid = Math.ceil(Math.random() * 1000);
      this.orderUUID = uuid;
      setTimeout(() => {
        if (uuid != this.orderUUID) {
          return;
        }
        this.doCreateOrder();
      }, 100);
    },
    doCreateOrder() {
      this.payLoading = true;
      let now = new Date();
      let nowHour = parseInt(now.getHours());
      let nowMin = parseInt(now.getMinutes());
      if (nowHour >= 21) {
        this.$router.push("unSell");
        return;
      }
      if (nowHour < 8) {
        this.$router.push("unSell");
        return;
      }
      if (!this.orderId && !this.orderIndex) {
        if (!this.getGoodsList) {
          return;
        }
        // console.log('123');
        this.sordedBy();
        let subStarOrders = [];
        for (let goods of this.getGoodsList) {
          let upPrice = 0;
          goods.specs.forEach((item) => {
            upPrice = upPrice + item.upPrice;
          });
          subStarOrders.push({
            foodPrice: goods.foodPrice + upPrice,
            foodId: goods.goodsId,
            foodName: goods.name,
            foodNum: goods.goodsNum,
            xtyFoodPrice: goods.HcPrice + upPrice,
            officialPrice: goods.officialPrice + upPrice,
            thumb: goods.thumb,
            specification: goods.specification,
            // foodPrice: 1,
            // officialPrice: 1,
            // xtyFoodPrice: 1,
          });
        }
        // return false
        // orderIndex 控制是否可以再次创建订单
        this.orderIndex = true;
        if (this.payType === "1") {
          // 余额支付
          getYuedongAccount({}).then((res) => {
            this.sSetUserInfo(res);
            if (res.amount == 0) {
              Dialog.confirm({
                title: "下单失败",
                message: "余额不足，请重试",
              });
              this.sortGoodList = [];
              this.sortCardList = [];
              // 余额支付失败后可以再次下单
              this.orderIndex = false;
              this.payLoading = false;
            } else {
              addOrder({
                address: this.sShop.shopAddress,
                storeName: this.sShop.shopName,
                location: this.sShop.lonAndLat,
                phone: this.sUserInfo.mobile,
                takeFoodWey: "店内取餐",
                subStarOrders: subStarOrders,
              })
                .then((res) => {
                  let orderId = res;
                  this.setOrderId(orderId);
                  // if (this.payType === "1") {
                  this.amountPay(orderId);
                  // } else {
                  //   this.wechartPay(orderId);
                  // }
                })
                .catch((err) => {
                  this.payLoading = false;
                  this.orderIndex = false;
                });
            }
          });
        } else if (this.payType == "2") {
          // 微信支付
          addOrder({
            address: this.sShop.shopAddress,
            storeName: this.sShop.shopName,
            location: this.sShop.lonAndLat,
            phone: this.sUserInfo.mobile,
            takeFoodWey: "店内取餐",
            subStarOrders: subStarOrders,
          })
            .then((res) => {
              let orderId = res;
              this.setOrderId(orderId);
              // if (this.payType === "1") {
              //   this.amountPay(orderId);
              // } else {
              if (this.isWechated == 0) {
                if (this.payWay.payWx == 1) {
                  this.hfWxPay(orderId);
                } else {
                  this.wechartPay(orderId);
                }
              } else {
                this.wechartPay(orderId);
              }
              // }
            })
            .catch((err) => {
              this.payLoading = false;
              this.orderIndex = false;
            });
        } else {
          // 支付宝支付
          addOrder({
            address: this.sShop.shopAddress,
            storeName: this.sShop.shopName,
            location: this.sShop.lonAndLat,
            phone: this.sUserInfo.mobile,
            takeFoodWey: "店内取餐",
            subStarOrders: subStarOrders,
          })
            .then((res) => {
              let orderId = res;
              this.setOrderId(orderId);
              this.aliPay(orderId);
            })
            .catch((err) => {
              this.payLoading = false;
              this.orderIndex = false;
            });
        }
      } else if (this.orderId) {
        // 再支付
        this.setOrderId(this.orderId);
        if (this.payType === "1") {
          this.amountPay(this.orderId);
        } else if (this.payType === "2") {
          if (this.isWechated == 0) {
            if (this.payWay.payWx == 1) {
              this.hfWxPay(this.orderId);
            } else {
              this.wechartPay(this.orderId);
            }
          } else {
            this.wechartPay(this.orderId);
          }
        } else {
          this.aliPay(this.orderId);
        }
      }
    },
    //官方微信支付
    wechartPay(orderId) {
      let browserFlag = this.isWechat();
      getWeixinPay({
        openId: localStorage.getItem("openId"),
        browserFlag: browserFlag,
        sortedGoodsIdList: this.sortGoodList.toString(),
        userCardId: this.sortCardList.length > 0 ? this.sortCardList : null,
        orderId: orderId,
      })
        .then((res) => {
          if (res.zeroFlag == 1) {
            this.$router.replace({
              name: "payBack",
            });
          } else {
            this.doPay(res);
          }
        })
        .catch((err) => {
          if (err.data && err.data.code == 500) {
            this.$router.push({
              name: "goods",
            });
          }
        });
    },
    // 付汇微信支付
    hfWxPay(orderId) {
      // let browserFlag = this.isWechat();

      otherGetWxPay({
        openId: localStorage.getItem("openId"),
        // openId: 'oBIPBwyLgmem-_aqEoPbFTb-LDyE',
        browserFlag: 0,
        sortedGoodsIdList: this.sortGoodList.toString(),
        userCardId: this.sortCardList.length > 0 ? this.sortCardList : null,
        orderId: orderId,
        baseTradeType: "common",
        basePayType: "ADA",
        baseChannel: "wx_pub",
      }).then((res) => {
        if (res.zeroFlag == 1) {
          this.$router.replace({
            name: "payBack",
          });
        } else {
          let str = location.search;
          let url = location.origin + location.pathname;
          if (str != " ") {
            saveUnit({
              ucode: url + str,
              outTradeNo: JSON.parse(res.jsApiParam).partyOrderId,
            });
          } else {
            saveUnit({
              ucode: url,
              outTradeNo: JSON.parse(res.jsApiParam).partyOrderId,
            });
          }
          this.doPay(res.jsApiParam);
        }
      });
    },
    aliPay(orderId) {
      // let browserFlag = this.isWechat();
      getAliPay({
        openId: localStorage.getItem("openId"),
        browserFlag: 1,
        sortedGoodsIdList: this.sortGoodList.toString(),
        userCardId: this.sortCardList.length > 0 ? this.sortCardList : null,
        baseTradeType: "common",
        basePayType: "ADA",
        baseChannel: "alipay_qr",
        orderId: orderId,
      }).then((res) => {
        this.$router.replace({
          name: "payBack",
        });
        window.location.href = `alipays://platformapi/startapp?saId=10000007&qrcode=${res.mweb_url}`;
        // window.open(res.mweb_url,"_blank")
        // this.$emit('success',orderId)
      });
    },

    //余额支付
    amountPay(orderId) {
      this._orderId = orderId;
      let browserFlag = this.isWechat();
      // 是否需要补差价
      let isAllCover = false;
      isPayedByBalance({ orderId: orderId })
        .then((res) => {
          if (res >= 0) {
            isAllCover = false;
          } else {
            isAllCover = true;
          }
        })
        .then(() => {
          if (isAllCover) {
            this.messages = "余额不足，剩余部分";
            if (this.isWechated == 0) {
              this.messages += "使用微信支付";
            } else {
              this.messages +=
                this.payWay.payH5 == 2
                  ? "使用支付宝支付"
                  : this.payWay.payH5 == 3
                    ? "使用微信支付"
                    : "";
            }
            this.$nextTick(() => {
              this.showDialog = true;
            });
            // if(this.isWechated == 0){

            // }
            // if (this.payWay.payH5 == 1) {
            //   this.showDialog = true
            //   return
            // }
            /* Dialog.alert({
            message: messages,
            theme:'round-button',
            closeOnClickOverlay:true
          }).then(() => {
            if (this.isWechated == 0) {
              // 微信支付
              if(this.payWay.payWx==1){
                // 第三方微信支付
                this.toBalancePay(browserFlag,orderId,1)
              }else{
                // 官方微信支付
                this.toBalancePay(browserFlag,orderId,'')
              }
            } else {
              if (this.payWay.payH5 == 2) {
                this.toBalancePay(browserFlag,orderId,2)
              } else if(this.payWay.payH5 == 3) {
                this.toBalancePay(browserFlag,orderId,'')
              }
            }
          }).catch(()=>{
          this.payLoading = false
          }) */
          } else {
            this.toBalancePay(browserFlag, orderId, "");
          }
        });
    },
    toBalancePay(browserFlag, orderId, useHf) {
      let obj = null;
      if (useHf != "") {
        obj = {
          openId: localStorage.getItem("openId"),
          // openId: "oBIPBwyLgmem-_aqEoPbFTb-LDyE",
          browserFlag: browserFlag,
          userCardId: this.sortCardList.length > 0 ? this.sortCardList : null,
          orderId: orderId,
          useHf: useHf,
          baseTradeType: "common",
          basePayType: "ADA",
          baseChannel: useHf == 1 ? "wx_pub" : "alipay_qr",
        };
      } else {
        obj = {
          openId: localStorage.getItem("openId"),
          browserFlag: browserFlag,
          userCardId: this.sortCardList.length > 0 ? this.sortCardList : null,
          orderId: orderId,
          useHf: useHf,
        };
      }
      getBalancePay(obj).then((res) => {
        if (res.payType == 1) {
          if (this.orderPayType == 1) {
            this.$emit("success", orderId);
          } else {
            this.toOrder(orderId);
          }
          this.payLoading = false;
        } else {
          if (this.isWechated == 0) {
            // 微信支付
            if (this.payWay.payWx == 1) {
              let str = location.search;
              let url = location.origin + location.pathname;
              if (str != " ") {
                saveUnit({
                  ucode: url + str,
                  outTradeNo: JSON.parse(res.jsApiParam).partyOrderId,
                });
              } else {
                saveUnit({
                  ucode: url,
                  outTradeNo: JSON.parse(res.jsApiParam).partyOrderId,
                });
              }
              this.doPay(res.jsApiParam);
            } else {
              this.doPay(res);
            }
          } else {
            if (useHf == "") {
              this.doPay(res);
            } else {
              // console.log(res);
              this.$router.replace({
                name: "payBack",
              });
              window.location.href = `alipays://platformapi/startapp?saId=10000007&qrcode=${res.mweb_url}`;
              // window.location.href = res.mweb_url
              // window.open(res.mweb_url,"_blank")
            }
          }
        }
      });
    },

    //支付成功
    toOrder(orderId) {
      this.$router.replace({
        name: "orderDetail",
      });
    },
    // 支付过程
    doPay(res) {
      this.clearGoodsList();
      let type = this.isWechat();
      if (type == 0) {
        if (this.payWay.payWx == 1) {
          let obj = JSON.parse(res);
          let params = obj.expend ? JSON.parse(obj.expend.pay_info) : obj;
          this.jsApi(params, 1);
        } else {
          this.jsApii = JSON.stringify(res);
          //JSAPi支付
          let params = JSON.parse(res.jsApiParam);
          this.jsApi(params, 2);
        }
      } else {
        let uri = JSON.parse(res.mweb_url);
        // let payBack = "https://kf.xty86.com/#/payBack";
        // let payBack = `${location.protocol}//${location.host}`
        let payBack = `https://kf.xty86.com/${location.search}#/payBack`;
        window.location.href =
          uri.h5_url + "&redirect_url=" + encodeURIComponent(payBack);
      }
    },
    jsApi(params, type) {
      const _this = this;
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: params.appId, //公众号名称，由商户传入
          timeStamp: params.timeStamp, //时间戳，自1970年以来的秒数
          nonceStr: params.nonceStr, //随机串
          package: params.package, //预支付返回数据
          signType: params.signType, //微信签名方式：
          paySign: params.paySign, //微信签名
        },
        function (res) {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            if (type == 1) {
              if (location.search == "") {
                location.href = `/#/orderDetail`;
              } else {
                location.href = `${location.search}#/orderDetail`;
              }
            }
            _this.$emit("success", _this.orderId);
            //支付成功后跳转的页面
          } else {
            _this.$router.push({
              name: "historyOrder",
            });
          }
        }
      );
    },
    isWechat() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return 0;
      } else {
        return 1;
      }
    },
  },
};
</script>

<style scoped>
.pay-type-logo {
  width: 40px;
  height: 40px;
}

.pay-type-text {
  font-weight: 580;
  color: #2a2a2a;
  font-size: 15px;
  margin-left: 10px;
}

.pay-account-sum {
  color: #919191;
  font-size: 14px;
}

.pay-type-div {
  background-color: #ffffff;
}

.pay-type-div .van-cell::after {
  border: none;
}

.do-pay-btn button {
  width: 100%;
  font-size: 16px;
  margin: 15px 0px;
  border-radius: 0px;
}

.pay-type {
  width: 100%;
  height: 100%;
  padding-top: 10px;
}

.choosepay {
  width: 300px;
  height: 180px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  row-gap: 10px;
}

.btnbox {
  width: 100%;
  display: flex;
  margin-top: 10%;
  justify-content: space-around;
}

.paybtn {
  width: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 4px;
  border-radius: 8px;
  padding: 0;
  height: 30px;
  font-size: 15px;
}

.othbtn {
  margin-top: 20px;
  width: 100px;
  height: 36px;
}

.paybtnimg {
  width: 30px;
  height: 30px;
}
</style>
